import React from "react";
import { View, Pressable } from "react-native";
import { Text } from "../Text";
import { useNumericKeypadStyles } from "./styles";

const DIGIT_ROWS = [
  ["1", "2", "3"],
  ["4", "5", "6"],
  ["7", "8", "9"],
];

interface NumericKeypadProps {
  onDigitPress: (digit: string) => void;
}

const NumericKeypad: React.FC<NumericKeypadProps> = ({ onDigitPress }) => {
  const styles = useNumericKeypadStyles();

  const renderDigit = (digit: string) => (
    <Pressable
      key={digit}
      testID={`keypadKey-${digit}`}
      accessibilityRole="button"
      accessibilityLabel={digit}
      onPress={() => onDigitPress(digit)}
      style={styles.key}
    >
      <Text style={styles.keyText}>{digit}</Text>
    </Pressable>
  );

  return (
    <View testID="numericKeypad" style={styles.container}>
      {DIGIT_ROWS.map((row) => (
        <View key={row.join("")} style={styles.row}>
          {row.map(renderDigit)}
        </View>
      ))}
      <View style={styles.row}>
        <View style={styles.emptyKey} />
        {renderDigit("0")}
        <View style={styles.emptyKey} />
      </View>
    </View>
  );
};

export default NumericKeypad;
